import { render, staticRenderFns } from "./transactionTable.vue?vue&type=template&id=47f58e0c&scoped=true"
import script from "./transactionTable.vue?vue&type=script&lang=js"
export * from "./transactionTable.vue?vue&type=script&lang=js"
import style0 from "./transactionTable.vue?vue&type=style&index=0&id=47f58e0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f58e0c",
  null
  
)

export default component.exports